import React, { startTransition, useEffect, useState } from 'react';
import SearchPageSidebarSection from './SearchPageSidebarSection';
import { bool, func, object } from 'prop-types';
import { useMemo } from 'react';

/**
 * CONFIGURATION
 */

/* Sort types */
const sortMap = {
    SORT_TYPE_DEFAULT: {
        param: '',
        text: 'Default',
    },
    SORT_TYPE_ID_ASC: {
        param: 'id_asc',
        text: 'Older',
    },
    SORT_TYPE_ID_DESC: {
        param: 'id_desc',
        text: 'Newer',
    },
    SORT_TYPE_AZ_ASC: {
        param: 'title_asc',
        text: 'Title: A-Z, ascending',
    },
    SORT_TYPE_AZ_DESC: {
        param: 'title_desc',
        text: 'Title: A-Z, descending',
    },
    SORT_TYPE_PRICE_ASC: {
        param: 'price_asc',
        text: 'Price: lowest to highest',
    },
    SORT_TYPE_PRICE_DESC: {
        param: 'price_desc',
        text: 'Price: highest to lowest',
    },
    SORT_TYPE_TOP_RATED: {
        param: 'top_rated',
        text: 'Product: Top Rated',
    },
    SORT_TYPE_BEST_SELLING: {
        param: 'best_selling',
        text: 'Product: Best Selling',
    },
};

/* Limit Values */
export const median = (arr = []) => {
    const sortedArr = [...arr]
        .filter((n) => !isNaN(parseInt(n)))
        .map((n) => parseInt(n));
    const half = Math.floor(sortedArr.length / 2);
    return sortedArr.length % 2 === 0 ?
        sortedArr[half] : (sortedArr[half - 1] + sortedArr[half]) / 2;
};
export const limitSet = [8, 16, 24, 48, 64, 76];

/**
 * @function isValidPrice
 * @param {*} price
 * @param {*} comparePrice
 * @param {*} allowZero
 * @returns
 */
const isValidPrice = (price, comparePrice = null, allowZero = false) =>
    (price === ''
        || price === undefined
        || price === null)
        ? null
        : (!isNaN(parseFloat(price))
            && parseFloat(price) > (isValidPrice(comparePrice)
                ? parseFloat(comparePrice)
                : (allowZero ? -1 : 0)));

export default function SearchPageSidebar({ isMobile, searchQuery, setSearchQuery }) {
    const [minPrice, setMinPrice] = useState('');
    const [maxPrice, setMaxPrice] = useState('');
    const [selectedVendor, setSelectedVendor] = useState('');
    const [sortType, setSortType] = useState('');
    const [limit, setLimit] = useState('');
    useEffect(() => {
        startTransition(() => {
            setMinPrice(searchQuery.minPrice ?? '');
            setMaxPrice(searchQuery.maxPrice ?? '');
        });
    }, [searchQuery.minPrice, searchQuery.maxPrice]);
    const searchVendor = useMemo(() => searchQuery?.v ?? '', [searchQuery]);
    useEffect(() => {
        startTransition(() => {
            setSelectedVendor(searchVendor);
        });
    }, [searchVendor]);
    useEffect(() => {
        startTransition(() => {
            setSortType(searchQuery.sortBy);
        });
    }, [searchQuery.sortBy]);
    useEffect(() => {
        startTransition(() => {
            setLimit(limitSet.includes(parseInt(searchQuery.limit)) ? searchQuery.limit : '');
        });
    }, [searchQuery.limit]);
    /* Custom sort */
    const handleSetSortType = (e) => {
        e.preventDefault();
        let { value } = e.target;
        const findValueParamInSortMap = Object.values(sortMap)
            .filter((v) => v.param === value);
        if (!findValueParamInSortMap.length) {
            value = sortMap[Object.keys(sortMap)[0]].param;
            return;
        }
        setSortType(value);
        setSearchQuery({
            ...searchQuery,
            sortBy: value,
            sort: null,
        });
    };
    /* End custom sort */
    return (<div
        className={'search-page--sidebar'}>
        <SearchPageSidebarSection
            isMobile={isMobile}
        >
            <div
            >
                <div
                    style={{
                        display: 'flex',
                        whiteSpace: 'nowrap',
                        gap: '6px',
                        marginLeft: '10px',
                        alignItems: 'center',
                    }}>
                    <span><b
                        className={'text-muted'}>Sort by</b></span>
                    <select
                        className={'search-sidebar--input'}
                        name={'Sort by'}
                        value={sortType}
                        onChange={handleSetSortType}>
                        {Object.entries(sortMap).map(([k, v]) => (
                            <option
                                key={k}
                                value={v.param}>{v.text}</option>
                        ))}
                    </select>
                </div>
            </div>
        </SearchPageSidebarSection>
    </div >);
}

SearchPageSidebar.propTypes = {
    isMobile: bool,
    searchQuery: object,
    setSearchQuery: func,
};